/** Keep a chosen country when the number is still empty. */
export function shouldApplyPhoneCountryFallback(input: {
  userSelected: boolean;
  hasNationalNumber: boolean;
}): boolean {
  return !input.userSelected && !input.hasNationalNumber;
}
